import { render, staticRenderFns } from "./StoryCreate.vue?vue&type=template&id=2ab484f8"
import script from "./StoryCreate.vue?vue&type=script&lang=js"
export * from "./StoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports